import { isIso4217Currency } from '@vello/core';
import { formatMoney } from '@vello/format';
import type { ActiveIncentiveView } from '@vello/api-client';
import { bpToPercentText } from '../../../src/index';

/** A wire amount (`{ amountMinor, currency }`) as money text in the operator's language; an unreadable one shows as typed, never as a guess. */
export function wireMoney(m: { readonly amountMinor: string; readonly currency: string } | null | undefined, lang: string): string {
  if (m === null || m === undefined) return '—';
  return /^-?\d+$/.test(m.amountMinor) && isIso4217Currency(m.currency) ? formatMoney({ amountMinor: BigInt(m.amountMinor), currency: m.currency }, { locale: lang, timeZone: 'UTC', measurement: 'metric' }) : `${m.amountMinor} ${m.currency}`;
}

/** Minor units as money text (a chart value, an axis tick). */
export function minorMoney(amountMinor: number, currency: string, lang: string): string {
  return wireMoney({ amountMinor: String(Math.round(amountMinor)), currency }, lang);
}

export type Translate = (id: string, vars?: Record<string, string | number>) => string;
export type Vocab = (vocabulary: string, code: string) => string;

/** The one-line description of an offer, with the words the Active incentives screen owns (`offers.offer.*`). */
export function offerLine(o: ActiveIncentiveView, t: Translate, v: Vocab, money: (m: { readonly amountMinor: string; readonly currency: string }) => string): string {
  const lever = v('active_incentive.lever', o.lever);
  if ('subsidyBp' in o.value) return t('offers.offer.subsidy', { lever, percent: bpToPercentText(o.value.subsidyBp), cap: money(o.value.perOrderCap) });
  if ('guaranteePerHour' in o.value) return t('offers.offer.guarantee', { lever, rate: money(o.value.guaranteePerHour), minutes: o.value.minOnlineMinutes, acceptance: bpToPercentText(o.value.minAcceptanceBp) });
  if ('discountBp' in o.value) return t('offers.offer.line', { lever, percent: bpToPercentText(o.value.discountBp), cap: money(o.value.perRideCap) });
  return t('offers.offer.boost', { lever, amount: money(o.value.boost) });
}
